import { hydrate } from 'svelte';
import BrowseByLocation from './BrowseByLocation.svelte';

const el = document.getElementById('browse-by-location');
if (el) {
  const raw = el.getAttribute('data-props');
  const data = raw ? JSON.parse(raw) : { cities: [] };

  hydrate(BrowseByLocation, {
    target: el,
    props: {
      cities: data.cities || []
    }
  });
} else {
  console.error('BrowseByLocation element not found');
}
